module.exports = __webpack_public_path__ + "static/media/BANNER_FES.dfa0d996.jpg";